import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { BreadcrumbItem } from './BreadcrumbItem';
import { FONTS } from './constants';
export const Breadcrumb = ({ breadcrumbItems = [], divider = '>', size = 's', tailing = false, useLinkEffectOnHoverOnly = false, }) => {
    const font = FONTS[size];
    const hasDivider = (index) => tailing || index + 1 < breadcrumbItems.length;
    return (_jsx(Box, { flexWrap: "wrap", children: breadcrumbItems.map((tab, index) => (_jsxs(Box, { children: [_jsx(BreadcrumbItem, { font: font, tab: tab, useLinkEffectOnHoverOnly: useLinkEffectOnHoverOnly }), hasDivider(index) && (_jsx(Box, { font: font, px: 2, children: divider }))] }, index))) }));
};
//# sourceMappingURL=Breadcrumb.js.map